import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_GESCON_SEF_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterComprometimentos() {
        return axiosJwt
            .get(`${api}/gescon/comprometimentos/fornecedor`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentosPorVencimentos() {
        return axiosJwt
            .get(`${api}/gescon/comprometimentos/fornecedor/vencimentos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoPorId(comprometimentoId) {
        return axiosJwt
            .get(`${api}/gescon/comprometimentos/fornecedor/${comprometimentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexos(comprometimentoId) {
        return axiosJwt
            .get(`${api}/gescon/comprometimentos/fornecedor/${comprometimentoId}/anexos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTiposAnexos() {
        return axiosJwt
            .get(`${api}/gescon/comprometimentos/fornecedor/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirAnexo(comprometimentoAnexoNovo) {
        const formData = new FormData()
        formData.append('idComprometimento', comprometimentoAnexoNovo.idComprometimento)
        formData.append('comprometimentoAnexoTipoId', comprometimentoAnexoNovo.comprometimentoAnexoTipoId)
        formData.append('nomeArquivo', comprometimentoAnexoNovo.nomeArquivo)
        formData.append('arquivo', comprometimentoAnexoNovo.arquivo)

        return axiosJwt
            .post(`${api}/gescon/comprometimentos/fornecedor/anexos`, formData)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(comprometimentoAnexoExcluido) {
        return axiosJwt
            .delete(`${api}/gescon/comprometimentos/fornecedor/anexos`, {
                data: comprometimentoAnexoExcluido
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    downloadAnexo(comprometimentoId, comprometimentoAnexoId) {
        return axiosJwt
            .get(`${api}/gescon/comprometimentos/fornecedor/${comprometimentoId}/anexos/${comprometimentoAnexoId}`, {
                responseType: 'blob'
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(comprometimentoId) {
        return axiosJwt
            .get(`${api}/gescon/comprometimentos/fornecedor/${comprometimentoId}/timeline`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}